import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {AddPanels} from './AddPanels/AddPanels';
import {INITIAL_DRAWER_WIDTH_CLASS_NAME} from './constants';
import {WorkspaceCreateTriggerDrawerWrapper} from './CreateTrigger/WorkspaceCreateTriggerDrawerWrapper';
import {FloatingWorkspaceDrawer} from './FloatingWorkspaceDrawer';
import {InlineWorkspaceDrawer} from './InlineWorkspaceDrawer';
import {PanelsQuickAdd} from './PanelsQuickAdd/PanelsQuickAdd';
import {MediaSettingsDrawer} from './Settings/media/MediaSettingsDrawer';
import {SectionSettingsContent} from './Settings/SectionSettingsContent';
import {WorkspaceSettingsContent} from './Settings/WorkspaceSettingsContent';
import {useWorkspaceDrawerContext} from './WorkspaceDrawerContextProvider';

export const WorkspaceDrawer = () => {
  const {closeWorkspaceDrawer, contentType, drawerType} =
    useWorkspaceDrawerContext();

  const isDrawerOpen = contentType != null;

  if (drawerType === 'inline') {
    return (
      <InlineWorkspaceDrawer isDrawerOpen={isDrawerOpen}>
        <div
          className={twMerge(
            'flex h-full flex-col',
            'bg-white',
            'border-l border-moon-250 ',
            INITIAL_DRAWER_WIDTH_CLASS_NAME
          )}>
          <div className="sticky top-0" data-test="workspace-drawer">
            <WorkspaceDrawerContent />
          </div>
        </div>
      </InlineWorkspaceDrawer>
    );
  }

  return (
    <Tailwind>
      <FloatingWorkspaceDrawer
        isDrawerOpen={isDrawerOpen}
        closeWorkspaceDrawer={closeWorkspaceDrawer}>
        <div className="w-full" data-test="workspace-drawer">
          <WorkspaceDrawerContent />
        </div>
      </FloatingWorkspaceDrawer>
    </Tailwind>
  );
};

export const WorkspaceDrawerContent = () => {
  const {contentType, delayedContentType, targetPanelRef, targetSectionRef} =
    useWorkspaceDrawerContext();

  // to ensure the drawer contents don't abruptly disappear during the
  // "drawer closing" transition, we must use delayedContentType so the
  // contents remain visible until the drawer is fully closed.
  const displayedContentType = contentType ?? delayedContentType;

  if (displayedContentType === 'add-panels') {
    return <AddPanels />;
  }

  if (displayedContentType === 'panels-quick-add') {
    return <PanelsQuickAdd />;
  }

  if (displayedContentType === 'workspace-settings') {
    return (
      <WorkspaceSettingsContent displayedContentType={displayedContentType} />
    );
  }

  if (
    displayedContentType === 'media-settings' &&
    targetPanelRef != null &&
    targetSectionRef != null
  ) {
    return (
      <MediaSettingsDrawer
        panelRef={targetPanelRef}
        panelBankSectionConfigRef={targetSectionRef}
      />
    );
  }

  if (displayedContentType === 'section-settings') {
    return (
      <SectionSettingsContent displayedContentType={displayedContentType} />
    );
  }

  if (displayedContentType === 'create-trigger') {
    return <WorkspaceCreateTriggerDrawerWrapper />;
  }

  return null;
};
